export const passengerType = {
  adult: "Adult",
  child: "Child",
  infant: "Infant(0-1)",
};
